import { apiService } from './apiService';

// Import missing types and API functions
import * as MissingTypes from './missing-types';

// Export them under a namespace to avoid conflicts
export { MissingTypes };

// Re-export the original API service
export * from './apiService';

// Billing reads share one narrow invalidation boundary; call/room caches are independent.
apiService.enhanceEndpoints({
  endpoints: {
    billingInsightsControllerRead: {
      providesTags: ['CompanyBilling'],
      extraOptions: { silent: true },
    },
    billingUsageControllerCalls: {
      providesTags: ['CompanyBilling'],
      extraOptions: { silent: true },
    },
    billingUsageControllerRead: {
      providesTags: ['CompanyBilling'],
      extraOptions: { silent: true },
    },
    stripeBillingHistoryControllerDocument: { extraOptions: { silent: true } },
    stripeAutoTopUpControllerUpdate: { invalidatesTags: ['CompanyBilling'] },
    billingControllerCompany: { providesTags: ['CompanyBilling'] },
    billingControllerManager: { providesTags: ['CompanyBilling'] },
    billingControllerOffers: { providesTags: ['CompanyBilling'] },
    stripeBillingHistoryControllerRead: {
      providesTags: ['CompanyBilling'],
      extraOptions: { silent: true },
    },
    billingControllerPaymentExceptions: { providesTags: ['CompanyBilling'] },
    billingControllerResolvePaymentException: { invalidatesTags: ['CompanyBilling'] },
  },
});
